var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoMini(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29.394653,
    height: 29.394684,
    viewBox: "0 0 29.394653 29.394683",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath32-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 1190.551 V 0 H 0 Z",
    transform: "translate(-925.11482,-470.59211)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath34-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 1190.551 V 0 H 0 Z",
    transform: "translate(-922.53122,-461.40501)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1433.7033,-492.59526)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -5.066,0 -9.188,-4.121 -9.188,-9.187 0,-5.066 4.122,-9.187 9.188,-9.187 5.066,0 9.186,4.121 9.186,9.187 C 9.186,-4.121 5.066,0 0,0 m 0,-20.21 c -6.079,0 -11.024,4.945 -11.024,11.023 0,6.078 4.945,11.023 11.024,11.023 6.077,0 11.022,-4.945 11.022,-11.023 C 11.022,-15.265 6.077,-20.21 0,-20.21",
    style: {
      fill: "#ed1c24",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1448.4019,495.04324)",
    clipPath: "url(#clipPath32-9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C 0,1.427 1.157,2.583 2.583,2.583 4.01,2.583 5.167,1.427 5.167,0 5.167,-1.427 4.01,-2.583 2.583,-2.583 1.157,-2.583 0,-1.427 0,0",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1444.9571,507.2927)",
    clipPath: "url(#clipPath34-3)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMini);
export default __webpack_public_path__ + "static/media/logo-mini.47d2f73c3a795fd670d545923f70f6c3.svg";
export { ForwardRef as ReactComponent };